import 'bootstrap';

var ExamHistoryTable = require('./ExamHistoryTable');
var QuizHistoryTable = require('./QuizHistoryTable');
var Exam = require('./Exam');
var Review = require('./Review');
var Quiz = require('./Quiz');
var QuizReview = require('./QuizReview');

window.ExamHistoryTable = ExamHistoryTable;
window.QuizHistoryTable = QuizHistoryTable;

window.Exam = Exam;
window.Review = Review;
window.Quiz = Quiz;
window.QuizReview = QuizReview;
window.disablePrevious= function() {
    $('button.previous').attr('disabled','disabled');
};
window.enablePrevious = function() {
    $('button.previous').removeAttr('disabled');
};
window.disableNext = function () {
    $('button.next').attr('disabled','disabled');
};
window.enableNext = function () {
    $('button.next').removeAttr('disabled');
};

/*
Written: 5400 seconds/90 min
Pathology: 6600 seconds 110 min
Kodachromes: 4800 seconds 80 minutes
 */


//////////////////
// WEBPACK FOOTER
// ./src/app.js
// module id = 240
// module chunks = 0